import { DialogConfig } from "../lib/features/dialog/dialog.types";

const dialogRegistery = [
  {
    name: "removeFavorites",
    title: "Favorilerden Kaldır",
    description:
      "Seçili ürünleri favorilerinizden kaldırmak istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    cancelText: "İptal",
    confirmText: "Kaldır",
    variant: "destructive",
  },
  {
    name: "deleteCollection",
    title: "Koleksiyonu Sil",
    description:
      "Bu koleksiyonu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    cancelText: "İptal",
    confirmText: "Sil",
    variant: "destructive",
  },
  {
    name: "deleteReview",
    title: "Değerlendirmeyi Sil",
    description:
      "Bu değerlendirmeyi silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    cancelText: "İptal",
    confirmText: "Sil",
    variant: "destructive",
  },
] as const satisfies readonly DialogConfig[];

export type DialogName = (typeof dialogRegistery)[number]["name"];
export default dialogRegistery;
